const constants = {
  IMAGE_TYPE_SMALL: 'chico',
  IMAGE_TYPE_MEDIUM: 'mediano',
  IMAGE_TYPE_LARGE: 'grande',
  NUMBER_2000: 2000,
  NUMBER_5000: 5000
};

export default constants;



// WEBPACK FOOTER //
// ./src/constants/index.js